import '../styles/index.less';
import { SVGMask } from './svg-mask.js';
import { FilterAgenda } from '../../dekubus/js/filter-agenda.js';
import { favorites } from './favorites.js';


var init = {};

init.sync = function () {
	SVGMask.init();
	FilterAgenda.init(); // TODO Async maken!
	favorites.init();
}

/**
* Init Project
* * * * * * * * * * * *
*/
$(function () {
	init.sync();
});
